import type { MouseEvent } from 'react';
import { memo } from 'react';

import { Button, type ButtonProps } from '@clubspark-react/ui/core';

export interface StandardButtonProps extends Omit<ButtonProps, 'onClick'> {
  loading?: boolean;
  fullWidth?: boolean;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
}

const StandardButton = memo(({ children, loading, variant = 'tertiary', ref, ...props }: StandardButtonProps) => {
  return (
    <Button
      variant={variant}
      {...props}
      ref={ref}
      isLoading={loading || props.isLoading}
      styles={{ label: { display: 'flex', alignItems: 'center' } }}
      onClick={(e) => props.onClick?.(e)}
    >
      {children}
    </Button>
  );
});

export default StandardButton;
